module.exports = __webpack_public_path__ + "img/9.fa9cd733.jpg";